export default "__VITE_ASSET__b8f1024d__"